export default __webpack_public_path__ + "/dist/images/9445802.png";